import * as React from 'react';
import {FunctionComponent} from 'react';

interface OwnProps {}

export const OutdoorIntervalTablePromo: FunctionComponent<OwnProps> = ({}) => {
    return (
        <div className="card mt-3 intervaltable">
            <div className="card-title">
                <h5>Intervals</h5>
            </div>
            <div className="card-body-promo">
                <p>Get the full picture automated Interval Tables</p>
                <p>
                    We'll break down your outdoor workouts into intervals automatically providing you with a detailed
                    overview of your training.
                </p>
                <p>
                    <b>Level up your training — become an Advanced Member today!</b>
                </p>
                <a href="/account/subscriptions/checkout" className="btn btn-primary">
                    Become an Advanced Member
                </a>
            </div>
            <table className="table skeleton skeleton--opacity skeleton--static">
                <thead>
                    <tr>
                        <th className="intervaltable__cell">
                            <span>Duration</span>
                        </th>
                        <th className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>Distance</span>{' '}
                            <span className="intervaltable__cell-label">
                                <span>(m)</span>
                            </span>
                        </th>
                        <th className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>Ø Split</span>{' '}
                            <span className="intervaltable__cell-label">
                                <span>(/500m)</span>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="intervaltable__row">
                        <td className="intervaltable__cell">
                            <span>01:35.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>176</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>4:30.10</span>
                        </td>
                    </tr>
                    <tr className="intervaltable__row intervaltable__row--dimmed">
                        <td className="intervaltable__cell">
                            <span>05:02.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>76</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>32:57.88</span>
                        </td>
                    </tr>
                    <tr className="intervaltable__row">
                        <td className="intervaltable__cell">
                            <span>43:04.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>6,614</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>3:15.34</span>
                        </td>
                    </tr>
                    <tr className="intervaltable__row intervaltable__row--dimmed">
                        <td className="intervaltable__cell">
                            <span>02:28.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>86</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>14:17.62</span>
                        </td>
                    </tr>
                    <tr className="intervaltable__row">
                        <td className="intervaltable__cell">
                            <span>00:58.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>78</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>6:11.49</span>
                        </td>
                    </tr>
                    <tr className="intervaltable__row intervaltable__row--dimmed">
                        <td className="intervaltable__cell">
                            <span>01:37.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>81</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>10:01.47</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
